function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 188 97",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-video",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "125.428 34.214 105.429 48.5 125.428 62.786 125.428 34.214",
    style: {
      stroke: "rgb(196, 196, 196)",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.572,
    y: 28.5,
    width: 42.857,
    height: 40,
    rx: 2,
    ry: 2,
    style: {
      stroke: "rgb(196, 196, 196)",
      strokeWidth: 5
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.24d64017d47ccc1558e7f382c4f62a41.svg";
export { ForwardRef as ReactComponent };